import { render, staticRenderFns } from "./pill-tabs.vue?vue&type=template&id=80fd142c&scoped=true&"
import script from "./pill-tabs.vue?vue&type=script&lang=js&"
export * from "./pill-tabs.vue?vue&type=script&lang=js&"
import style0 from "./pill-tabs.vue?vue&type=style&index=0&id=80fd142c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fd142c",
  null
  
)

export default component.exports